// extracted by mini-css-extract-plugin
module.exports = {"person":"Person_person__djZ8J","personName":"Person_personName__lP4NN","personMissing":"Person_personMissing__25eQA"};